<div class="container-fluid clone-history-page">
  <!-- Page Heading -->
  <nav class="navbar sticky-top batch-page__nav">
    <div class="d-grid gap-2 d-flex navbar-brand">
      <button
        (click)="location.back()"
        type="button"
        class="btn btn-primary"
        aria-label="Back"
        ngbTooltip="Back"
        placement="bottom"
      >
        <fa-icon [icon]="faAngleLeft"></fa-icon>
      </button>
      <h2 class="mobileHeading">Job Details</h2>
    </div>
  </nav>

  @if (job(); as jobDetails) {
    <div class="page-card mb-4 mt-3">
      <div class="page-card__header">
        <div>
          <h5 class="page-card__title mb-1">
            {{ jobDetails.jobId }}
          </h5>

          <div class="text-muted small">
            Clone Job Details
          </div>
        </div>

        <span [class]="getStatusClass(jobDetails.status)">
          <span class="status-dot"></span>
          {{ jobDetails.status | titlecase }}
        </span>
      </div>

      <div class="page-card__body">
        <div class="details-summary">
          <div class="details-summary__item">
            <div class="details-summary__label">
              Created By
            </div>

            <div class="details-summary__value">
              {{ jobDetails.createdByName || '-' }}
            </div>
          </div>

          <div class="details-summary__item">
            <div class="details-summary__label">
              Created At
            </div>

            <div class="details-summary__value">
              @if (jobDetails.createdAt) {
                {{ jobDetails.createdAt | date: 'MMM d, y, h:mm a' }}
              } @else {
                -
              }
            </div>
          </div>

          <div class="details-summary__item">
            <div class="details-summary__label">
              Completed At
            </div>

            <div class="details-summary__value">
              @if (jobDetails.completedAt) {
                {{ jobDetails.completedAt | date: 'MMM d, y, h:mm a' }}
              } @else {
                -
              }
            </div>
          </div>

          <div class="details-summary__item">
            <div class="details-summary__label">
              Total Items
            </div>

            <div class="details-summary__value">
              {{ jobDetails.totalItems }}
            </div>
          </div>

          <div class="details-summary__item">
            <div class="details-summary__label">
              Success
            </div>

            <div class="details-summary__value details-summary__value--success">
              {{ jobDetails.successCount }}
            </div>
          </div>

          <div class="details-summary__item">
            <div class="details-summary__label">
              Failed
            </div>

            <div class="details-summary__value details-summary__value--failed">
              {{ jobDetails.failedCount }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================================================== -->
    <!-- ONE RESULTS TABLE                                     -->
    <!-- ===================================================== -->
    <div class="page-card">
      <div class="page-card__header">
        <div>
          <h5 class="page-card__title mb-1">
            Clone Results
          </h5>

          <div class="text-muted small">
            {{ totalCount() }} result{{ totalCount() === 1 ? '' : 's' }}
          </div>
        </div>
      </div>

      <div class="page-card__body">
        <!-- ================================================= -->
        <!-- TABLE TOOLBAR                                     -->
        <!-- ================================================= -->
        <div class="results-toolbar">
          <!-- Status Filter -->
          <div class="results-toolbar__filter">
            <label
              for="resultStatusFilter"
              class="form-label"
            >
              Status
            </label>

            <select
              id="resultStatusFilter"
              class="form-select status-filter"
              [value]="statusFilter()"
              (change)="setStatusFilter($any($event.target).value)"
            >
              <option value="all">
                All Statuses
              </option>

              <option value="success">
                Success
              </option>

              <option value="pending">
                Pending
              </option>

              <option value="failed">
                Failed
              </option>

              <option value="errored">
                Errored
              </option>
            </select>
          </div>

          <!-- Search - pushed to right -->
          <div class="results-toolbar__search">
            <label
              for="resultSearch"
              class="form-label"
            >
              Search
            </label>

            <div class="input-group table-search">
              <input
                #searchInput
                id="resultSearch"
                type="text"
                class="form-control"
                placeholder="Search projects or clients..."
                [value]="searchValue()"
                (keydown.enter)="search(searchInput.value)"
              />

              <button
                class="btn btn-primary"
                type="button"
                (click)="search(searchInput.value)"
              >
                <i class="fa fa-search me-1"></i>
                Search
              </button>

              @if (searchValue()) {
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  (click)="clearSearch(searchInput)"
                >
                  Clear
                </button>
              }
            </div>
          </div>
        </div>

        <!-- ================================================= -->
        <!-- RESULT INFORMATION                                -->
        <!-- ================================================= -->
        <div class="table-result-info">
          @if (totalCount() > 0) {
            Showing
            <strong>
              {{ displayedRangeStart() }}
            </strong>
            to
            <strong>
              {{ displayedRangeEnd() }}
            </strong>
            of
            <strong>
              {{ totalCount() }}
            </strong>
            results
          } @else {
            No results found
          }

          @if (hasActiveFilters()) {
            <button
              type="button"
              class="clear-all-button"
              (click)="clearAllFilters(searchInput)"
            >
              Clear all filters
            </button>
          }
        </div>

        <!-- ================================================= -->
        <!-- SINGLE TABLE                                      -->
        <!-- ================================================= -->
        <div class="clone-table-container">
          <div class="clone-table-wrap">
            <table class="table clone-table align-middle">
              <thead>
                <tr>
                  <th>Source Project</th>
                  <th>Client Name</th>
                  <th>New Project</th>
                  <th>Project Name</th>
                  <th>Create Project Status</th>
                  <th>Clone Proposal Status</th>
                  <th>Auto Send Proposal Status</th>
                  <th>Auto Accept Status</th>
                  <th>Auto Invoice Status</th>
                  <th>Finalize</th>
                </tr>
              </thead>

              <tbody>
                @for (
                  result of viewRows();
                  track result.newProjectId || result.sourceProjectId || $index
                ) {
                  <tr>
                    <!-- ===================================== -->
                    <!-- SOURCE PROJECT                        -->
                    <!-- ===================================== -->
                    <td>
                      @if (result.sourceProjectId) {
                        <a
                          class="table-link"
                          [routerLink]="[
                            '/projects',
                            result.sourceProjectId
                          ]"
                        >
                          {{
                            result.sourceProjectTitle ||
                              'View Source Project'
                          }}
                        </a>
                      } @else {
                        <span class="empty-value">
                          -
                        </span>
                      }
                    </td>

                    <!-- ===================================== -->
                    <!-- CLIENT                                -->
                    <!-- ===================================== -->
                    <td>
                      @if (result.clientId) {
                        <a
                          class="table-link"
                          [routerLink]="[
                            '/clients',
                            result.clientId
                          ]"
                        >
                          {{
                            result.clientName ||
                              'View Client'
                          }}
                        </a>
                      } @else {
                        <span>
                          {{ result.clientName || '-' }}
                        </span>
                      }
                    </td>

                    <!-- ===================================== -->
                    <!-- NEW PROJECT LINK                      -->
                    <!-- ===================================== -->
                    <td>
                      @if (
                        result.newProjectId &&
                        isStepSuccessful(
                          result,
                          'CREATE_PROJECT'
                        )
                      ) {
                        <a
                          class="table-link"
                          [routerLink]="[
                            '/projects',
                            result.newProjectId
                          ]"
                        >
                          View Project
                        </a>
                      } @else {
                        <span class="empty-value">
                          -
                        </span>
                      }
                    </td>

                    <!-- ===================================== -->
                    <!-- PROJECT NAME                          -->
                    <!-- ===================================== -->
                    <td class="project-name-cell">
                      {{ result.newProjectName || '-' }}
                    </td>

                    <!-- ===================================== -->
                    <!-- CREATE PROJECT                        -->
                    <!-- ===================================== -->
                    <td>
                      @if (
                        getStep(
                          result,
                          'CREATE_PROJECT'
                        );
                        as step
                      ) {
                        <div class="status-cell">
                          <span
                            [class]="getStatusClass(step.status)"
                          >
                            <span class="status-dot"></span>

                            {{ step.status | titlecase }}
                          </span>

                          @if (step.info?.message) {
                            <div class="status-message">
                              {{ step.info?.message }}
                            </div>
                          }
                        </div>
                      } @else {
                        <span class="empty-value">
                          -
                        </span>
                      }
                    </td>

                    <!-- ===================================== -->
                    <!-- CLONE PROPOSAL                        -->
                    <!-- ===================================== -->
                    <td>
                      @if (
                        getStep(
                          result,
                          'CLONE_PROPOSALS'
                        );
                        as step
                      ) {
                        <div class="status-cell">
                          <span
                            [class]="getStatusClass(step.status)"
                          >
                            <span class="status-dot"></span>

                            {{ step.status | titlecase }}
                          </span>

                          @if (step.info?.message) {
                            <div class="status-message">
                              {{ step.info?.message }}
                            </div>
                          }
                        </div>
                      } @else {
                        <span class="empty-value">
                          -
                        </span>
                      }
                    </td>

                    <!-- ===================================== -->
                    <!-- AUTO SEND PROPOSAL                    -->
                    <!-- ===================================== -->
                    <td>
                      @if (
                        getStep(
                          result,
                          'AUTO_SEND_PROPOSAL'
                        );
                        as step
                      ) {
                        <div class="status-cell">
                          <span
                            [class]="getStatusClass(step.status)"
                          >
                            <span class="status-dot"></span>

                            {{ step.status | titlecase }}
                          </span>

                          @if (step.info?.message) {
                            <div class="status-message">
                              {{ step.info?.message }}
                            </div>
                          }
                        </div>
                      } @else {
                        <span class="empty-value">
                          -
                        </span>
                      }
                    </td>

                    <!-- ===================================== -->
                    <!-- AUTO ACCEPT                           -->
                    <!-- ===================================== -->
                    <td>
                      @if (
                        getStep(
                          result,
                          'AUTO_ACCEPT'
                        );
                        as step
                      ) {
                        <div class="status-cell">
                          <span
                            [class]="getStatusClass(step.status)"
                          >
                            <span class="status-dot"></span>

                            {{ step.status | titlecase }}
                          </span>

                          @if (step.info?.message) {
                            <div class="status-message">
                              {{ step.info?.message }}
                            </div>
                          }
                        </div>
                      } @else {
                        <span class="empty-value">
                          -
                        </span>
                      }
                    </td>

                    <!-- ===================================== -->
                    <!-- AUTO INVOICE                          -->
                    <!-- ===================================== -->
                    <td>
                      @if (
                        getStep(
                          result,
                          'AUTO_INVOICE'
                        );
                        as step
                      ) {
                        <div class="status-cell">
                          <span
                            [class]="getStatusClass(step.status)"
                          >
                            <span class="status-dot"></span>

                            {{ step.status | titlecase }}
                          </span>

                          @if (step.info?.message) {
                            <div class="status-message">
                              {{ step.info?.message }}
                            </div>
                          }
                        </div>
                      } @else {
                        <span class="empty-value">
                          -
                        </span>
                      }
                    </td>

                    <!-- ===================================== -->
                    <!-- FINALIZE                              -->
                    <!-- ===================================== -->
                    <td>
                      @if (
                        getStep(
                          result,
                          'FINALIZE'
                        );
                        as step
                      ) {
                        <div class="status-cell">
                          <span
                            [class]="getStatusClass(step.status)"
                          >
                            <span class="status-dot"></span>

                            {{ step.status | titlecase }}
                          </span>

                          @if (step.info?.message) {
                            <div class="status-message">
                              {{ step.info?.message }}
                            </div>
                          }
                        </div>
                      } @else {
                        <span class="empty-value">
                          -
                        </span>
                      }
                    </td>
                  </tr>
                } @empty {
                  <tr>
                    <td colspan="10">
                      <div class="empty-state">
                        No clone results found.
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <!-- ================================================= -->
        <!-- PAGINATION                                        -->
        <!-- ================================================= -->
        @if (totalCount() > 0) {
          <div class="row automation-table__footer">
            <!-- Page Size -->
            <div class="col">
              <div class="page-size-container">
                <span class="text-muted">
                  Show
                </span>

                <div ngbDropdown>
                  <button
                    type="button"
                    class="btn page-size-btn"
                    ngbDropdownToggle
                  >
                    {{ limit() }}
                  </button>

                  <div
                    ngbDropdownMenu
                    class="page-size-dropdown"
                  >
                    <button
                      ngbDropdownItem
                      (click)="setLimit(5)"
                    >
                      5
                    </button>

                    <button
                      ngbDropdownItem
                      (click)="setLimit(10)"
                    >
                      10
                    </button>

                    <button
                      ngbDropdownItem
                      (click)="setLimit(20)"
                    >
                      20
                    </button>

                    <button
                      ngbDropdownItem
                      (click)="setLimit(50)"
                    >
                      50
                    </button>
                  </div>
                </div>

                <span class="text-muted">
                  entries
                </span>
              </div>
            </div>

            <!-- Pagination -->
            <div class="col">
              <ngb-pagination
                class="d-flex justify-content-end custom-pagination"
                [page]="page()"
                [pageSize]="limit()"
                [collectionSize]="totalCount()"
                [boundaryLinks]="true"
                [maxSize]="3"
                [ellipses]="true"
                [rotate]="true"
                (pageChange)="setCurrentPage($event)"
              ></ngb-pagination>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>